function showSnackBar(msg,delay=3000){
    document.querySelector('#sf-snackBar') && document.querySelector('#sf-snackBar').parentElement.removeChild(document.querySelector('#sf-snackBar'));
    const snackBar = document.createElement('div');
    snackBar.id = 'sf-snackBar';
    snackBar.textContent = msg;
    document.querySelector('#sf-chat-main-container').appendChild(snackBar);
    setTimeout(() => {
        snackBar.parentElement.removeChild(snackBar);
    },delay);
}

export default showSnackBar;